export default __webpack_public_path__ + "static/service-icon-1-custom-aafcdcb9d7c1782b230501ceb315cf04.svg";